/**
 * @fileoverview ApiError class extending the native Error object.
 * It accepts an extra parameter, 'httpStatusCode', in addition to the message.
 */

/**
 * Extracts an error message from a given payload.
 * @param {any} payload - The payload to extract the message from.
 * @returns {string} The extracted error message.
 */
function extractErrorMessage(payload) {
    if (typeof payload === 'string') {
        return payload;
    }
    if (typeof payload === "object" && payload !== null && !Array.isArray(payload)) {
        return payload.message || payload.errorMessage || "An API error occurred.";
    }
    return "An API error occurred.";
}

class ApiError extends Error {
    /**
     * Creates an instance of ApiError.
     * @param {string|object} errorSource - The error message string or a response payload object.
     * @param {number|string} httpStatusCode - An extra parameter to identify the error type.
     */
    constructor(errorSource, httpStatusCode) {
        const message = extractErrorMessage(errorSource);

        // Call the parent Error constructor
        super(message);

        // Set the name of the error (good practice for identification)
        this.name = 'ApiError';

        // Store the HTTP status code
        this.httpStatusCode = httpStatusCode;

        // Store attributes from the error source if it's an object
        this.attributes = typeof errorSource === 'object' && errorSource !== null ? errorSource : {};

        // This line ensures the correct prototype chain and stack trace.
        // It is often necessary when extending built-in classes in older environments
        // or when targeting specific JavaScript engines, but is often optional
        // in modern environments (ES6+). It is safe to include.
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
    }
}

export default ApiError;